import { render, staticRenderFns } from "./AdsReportPanel.vue?vue&type=template&id=08ba858e"
import script from "./AdsReportPanel.vue?vue&type=script&lang=js"
export * from "./AdsReportPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports